import React, { useEffect, useState, useRef } from "react";
import "./header.css";
import LocalCategories from "../mainPage/Categories"; // Your hardcoded categories
import { Link } from "react-router-dom";
import urls from "../../Utility/URL/url.js";

const HeaderSection = () => {
  const [Categories, setCategories] = useState(LocalCategories);
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeCategoryMob, setActiveCategoryMob] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const searchRef = useRef(null);
  // ✅ Close side nav on load
  useEffect(() => {
    document.getElementById("mySidenav").style.width = "0";
    setActiveCategory(null);
    setActiveCategoryMob(null);
  }, []);
  useEffect(() => {
    function handleClickOutside(event) {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false); // hide suggestions
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  // ✅ Fetch categories from API with 5s timeout
  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    fetch(urls.POST_CATEGORY_ON_LANDINGPAGE, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      signal: controller.signal,
    })
      .then(async (res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        try {
          return await res.json();
        } catch (e) {
          const text = await res.text();
          throw new Error(`Invalid JSON: ${text.slice(0, 100)}...`);
        }
      })
      .then((data) => {
        clearTimeout(timeoutId);
        setCategories(data);
        // console.log("✅ API categories loaded", data);
      })
      .catch((err) => {
        // console.error("❌ Error fetching categories", err);
      });

    return () => clearTimeout(timeoutId);
  }, []);

  function toggleSideNav() {
    setActiveCategoryMob(null);
    document.getElementById("mySidenav").style.width = "100%";
  }

  function closeSideNav() {
    setActiveCategoryMob(null);
    document.getElementById("mySidenav").style.width = "0";
  }

  const toggleCategory = (category) => {
    setActiveCategoryMob(activeCategoryMob === category ? null : category);
  };

  const handleMouseEnter = (category) => {
    setActiveCategory(category);
  };

  const handleMouseLeave = () => {
    setActiveCategory(null);
  };

  useEffect(() => {
    if (!searchTerm.trim()) {
      setSearchResults([]);
      setLoading(false);
      return;
    }

    setLoading(true); // Start loading

    const delayDebounce = setTimeout(() => {
      const searchUrl =
        urls.POST_SEARCH_ON_LANDINGPAGE + encodeURIComponent(searchTerm);

      fetch(searchUrl)
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data)) {
            // Filter only users who have fullName and profilePic
            const validResults = data.filter(
              (item) => item.fullName && item.profilePic
            );
            setSearchResults(validResults);
          } else {
            setSearchResults([]);
          }
        })
        .catch((err) => {
          // console.error("❌ Error fetching search suggestions", err)
        })
        .finally(() => setLoading(false)); // Stop loading
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  //hide search-suggestions div when click outside of input
  useEffect(() => {
    function handleClickOutside(e) {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setShowSuggestions(false); 
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <div className="header-block">
      <div className="header-wrapper flex justify-content-between">
        <a variant="base" className="header-logo" href="/">
          <div className="logo-wrapper" data-testid="logo" width="auto">
            Advising Buddy
          </div>
        </a>
        <ul className="item-list">
          <li className="category-item">
            <div
              className="dropdown"
              onMouseEnter={() => setShowSuggestions(false)}
            >
              <span id="header-menu-item-0" className="dropdown-toggle">
                Categories
              </span>

              <div   className={`dropdown-menu ${activeCategory ? "expanded" : ""}`} onMouseLeave={handleMouseLeave}>
                {/* Left Column */}
                <div style={{ minWidth: "280px" }}>
                  <div className="dropdown-header">
                    <div className="dropdown-title">Expert Categories</div>
                    <div className="dropdown-subtitle">
                      Find the perfect expert for your needs
                    </div>
                  </div>

                  <div
                    className={`dropdown-column-left ${
                      activeCategory ? "" : "w-100 min-w-210"
                    }`}
                  >
                    <div className="section-label">Popular Categories</div>
                    {Object.keys(Categories).map((category, index) => (
                      <div
                        key={index}
                        className="dropdown-item"
                        onMouseEnter={() => handleMouseEnter(category)}
                      >
                        <span>
                          {category.replace(/([A-Z])/g, " $1").trim()}
                        </span>
                        {activeCategory === category && (
                          <i className="fas fa-chevron-right"></i>
                        )}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Right Column */}
                {activeCategory && (
                  <div
                    className={`dropdown-column-right ${
                      activeCategory ? "show" : ""
                    }`}
                  >
                 
                      {Categories[activeCategory].map((json, idx) => {
                        const rating = Number(json.rating) || 0;

                        // background gradient logic
                        let bgColor =
                          "linear-gradient(173deg, #9ca3af, #6b7280)"; // default gray
                        if (rating >= 4.7) {
                          bgColor=" linear-gradient(135deg, #4ade80, #22c55e)";
                        } else if (rating >= 4.5) {
                          bgColor = "linear-gradient(135deg, #fb923c, #f97316)";;
                        } else if (rating > 0) {
                          bgColor = "linear-gradient(135deg, #fb3c3c, #f91616);";
                        }

                        // initials generator
                        const getInitials = (name) => {
                          if (!name) return "";
                          const nameParts = name.trim().split(" ");
                          if (nameParts.length === 1)
                            return nameParts[0][0].toUpperCase();
                          return (
                            nameParts[0][0].toUpperCase() +
                            nameParts[1][0].toUpperCase()
                          );
                        };

                        const isValidUrl =
                          json.profile && json.profile.startsWith("http");

                        return (
                          <div key={idx} className="dropdown-link">
                            <Link
                              to={`/${json.username}`}
                              className='user-item'
                            >
                              {/* Profile Pic or Initials */}
                             {isValidUrl ? (
  <div className="avatar-image">
    <img
      src={json.profile}
      alt={json.name}
      style={{
        borderRadius: "50%",
        objectFit: "cover",
        width: "43px",
        height: "43px",
      }}
    />
  </div>
) : (
  <div className="avatar-image">
    {getInitials(json.name)}
  </div>
)}


                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  width: "100%",
                                  alignItems:"center"
                                }}
                              >
                                <div>
                                  <h6 className="m-0">
                                    <small
                                      style={{
                                        fontFamily: "Nunito, sans-serif",
                                        fontOpticalSizing: "auto",
                                        fontWeight: "500",
                                        fontStyle: "normal",
                                        fontSize: "16px",
                                      }}
                                    >
                                      {json.name}
                                    </small>
                                  </h6>
                                </div>

                                {/* Rating Section */}
                                <div className="rating"
                                  style={{                             
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    
                                  }}
                                >
                                  {/* <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth="0"
                                    viewBox="0 0 576 512"
                                    color="#FFD700"
                                    height="12"
                                    width="12"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ color: " rgb(255, 215, 0)" }}
                                  >
                                    <path
                                      style={{ color: "#FFD700" }}
                                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                                    ></path>
                                  </svg> */}
                                  <div className="rating-badge" style={{ color: "white", background:bgColor }}>
                                    {rating > 0 ? rating.toFixed(1) : "N/A"}
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </div>
                        );
                      })}
                 
                  </div>
                )}
              </div>
            </div>
          </li>

          <li ref={searchRef}>
            <form className="form">
              <button>
                <svg
                  width="17"
                  height="16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-labelledby="search"
                >
                  <path
                    style={{ color: "gray" }}
                    d="M7.667 12.667A5.333 5.333 0 107.667 2a5.333 5.333 0 000 10.667zM14.334 14l-2.9-2.9"
                    stroke="currentColor"
                    strokeWidth="1.333"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </button>
              <input
                type="text"
                placeholder="Type your text"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setShowSuggestions(true);
                }}
                style={{ border: "none", width: "100%" }}
              />
            </form>
            {showSuggestions && searchTerm.trim() !== "" && (
              <div
                className={`search-suggestions ${
                  loading || searchResults.length > 0 ? "with-border" : ""
                }`}
              >
                {loading ? (
                  // Show 3 skeleton-cards
                  Array.from({ length: 3 }).map((_, idx) => (
                    <div className="skeleton-card" key={idx}>
                      <div className="skeleton-avatar"></div>
                      <div className="skeleton-content">
                        <div className="skeleton-line "></div>
                        <div className="skeleton-line short"></div>
                      </div>
                      <div className="skeleton-dot"></div>
                    </div>
                  ))
                ) : searchResults.length > 0 ? (
                  <ul className="list-group-numbered p-0">
                    {searchResults.map((item, idx) => {
                      const rating = Number(item.avgReviews) || 0;

                      // background gradient logic
                      let bgColor = "linear-gradient(173deg, #9ca3af, #6b7280)"; // default gray
                      if (rating >= 4.7) {
                        bgColor = "#069806";
                      } else if (rating >= 4.5) {
                        bgColor = "#d58f10";
                      } else if (rating > 0) {
                        bgColor = "yellow";
                      }

                      // initials generate karne ka function
                      const getInitials = (fullName) => {
                        if (!fullName) return "";
                        const nameParts = fullName.trim().split(" ");
                        if (nameParts.length === 1)
                          return nameParts[0][0].toUpperCase();
                        return (
                          nameParts[0][0].toUpperCase() +
                          nameParts[1][0].toUpperCase()
                        );
                      };

                      // check if profilePic is a valid URL
                      const isValidUrl =
                        item.profilePic && item.profilePic.startsWith("http");

                      return (
                        <li
                          key={idx}
                          className=""
                          style={{
                            borderBottom: "1px solid #e2e2e2",
                            padding: "12px 13px",
                          }}
                        >
                          <Link
                            to={`/${item.userName}`}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            {/* Profile Pic ya Initials */}
                            {isValidUrl ? (
                              <img
                                src={item.profilePic}
                                alt={item.fullName}
                                style={{
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  width: "43px",
                                  height: "43px",
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  width: "58px",
                                  height: "41px",
                                  borderRadius: "50%",
                                  backgroundColor: "#6b7280", // gray
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "13px",
                                }}
                              >
                                {getInitials(item.fullName)}
                              </div>
                            )}

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              <div>
                                <h6 className="m-0 ">
                                  <small
                                    style={{
                                      fontFamily: "Nunito , sans-serif",
                                      fontOpticalSizing: "auto",
                                      fontWeight: "500",
                                      fontStyle: "normal",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {item.fullName}
                                  </small>
                                </h6>
                                {item.expertise && (
                                  <p
                                    style={{
                                      fontSize: "13px",
                                      color: "gray",
                                      fontWeight: "500",
                                      margin: "0",
                                    }}
                                  >
                                    {item.expertise
                                      .replace(/([a-z])([A-Z])/g, "$1 $2") // space between camelCase
                                      .replace(/,/g, ", ")}
                                  </p>
                                )}
                              </div>

                              {/* Rating Section */}
                              <div
                                style={{
                                  background: bgColor,
                                  color: "#FFD700", // gold
                                  padding: "1px 7px",
                                  borderRadius: "12px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "3px",
                                  height: "fit-content",
                                }}
                              >
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  strokeWidth="0"
                                  viewBox="0 0 576 512"
                                  color="#FFD700"
                                  height="12"
                                  width="12"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{ color: " rgb(255, 215, 0)" }}
                                >
                                  <path
                                    style={{ color: "#FFD700" }}
                                    d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                                  ></path>
                                </svg>
                                <span style={{ color: "white" }}>
                                  {rating.toFixed(1)}
                                </span>
                              </div>
                            </div>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                ) : searchTerm.trim() !== "" ? (
                  // 🔹 No Results Case (only if user typed something)
                  <div style={{ height: "200px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        // gap: "10px",
                        padding: "10px",
                        color: "rgb(130 127 127)",
                        fontSize: "15px",
                        fontWeight: "600",
                        border: "1px solid #ddd",
                        borderTop: "none",
                        height: "100%",
                        justifyContent: "center",
                      }}
                    >
                      {/* <div
                    style={{
                      width: "35px",
                      height: "35px",
                      borderRadius: "50%",
                      backgroundColor: "#e5e7eb", // light gray
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <rect
                        x="3"
                        y="3"
                        width="18"
                        height="18"
                        rx="2"
                        ry="2"
                        fill="url(#gradDoc)"
                      />
                      <circle cx="9" cy="10" r="1.5" fill="white" />
                      <circle cx="15" cy="10" r="1.5" fill="white" />
                      <path
                        d="M8 16c1.333-1 2.667-1 4 0 1.333 1 2.667 1 4 0"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />

                      <defs>
                        <linearGradient
                          id="gradDoc"
                          x1="0"
                          y1="0"
                          x2="24"
                          y2="24"
                        >
                          <stop offset="0%" stopColor="#00c6ff" />
                          <stop offset="100%" stopColor="#0072ff" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div> */}
                      No user found
                    </div>
                  </div>
                ) : null}
              </div>
            )}
          </li>
        </ul>

        <ul className="auth-items">
          <li className="skip">
            <a className="login-button" href="/signin">
              <span>Log In</span>
            </a>
          </li>
          <li className="skip">
            <a href="/signup">
              <span className="signup-button">Sign Up</span>
            </a>
          </li>
        </ul>

        {/* Mobile Menu */}
        <div className="search-bar-wrapper d-lg-none">
          <div className="search-bar">
            <div className="search-button">
              <i className="fa fa-search "></i>
            </div>
          </div>
          <div className="menu-icon" onClick={toggleSideNav}>
            <div className="border border-black"></div>
            <div className="border border-black"></div>
            <div className="border border-black"></div>
          </div>
        </div>

        <div className="sideBar" id="mySidenav">
          <div className="sideNavBarBlock">
            <div className="d-flex justify-content-between align-items-center px-3 shadow-sm mb-3">
              <div className="logo-wrapper font-weight-bold">
                Advising Buddy
              </div>
              <span className="closebtn" onClick={closeSideNav}>
                &times;
              </span>
            </div>
            <ul className="item-list-mob">
              <li className="category-item w-100">
                <div id="category-menu">
                  <span
                    className="d-flex justify-content-between"
                    onClick={() => toggleCategory("category")}
                  >
                    Categories
                    <i
                      className={`fas fa-chevron-${
                        activeCategoryMob ? "up" : "down"
                      }`}
                    ></i>
                  </span>

                  <ul
                    className={`collapse collapse-content ${
                      activeCategoryMob ? "show" : ""
                    }`}
                  >
                    {Object.keys(Categories).map((category, index) => (
                      <li key={index}>
                        <span onClick={() => toggleCategory(category)}>
                          {category}
                          <i
                            className={`fas fa-chevron-${
                              activeCategoryMob === category ? "up" : "down"
                            }`}
                          ></i>
                        </span>

                        <ul
                          className={`collapse collapse-content ${
                            activeCategoryMob === category ? "show" : ""
                          }`}
                        >
                          {Categories[category].map((json, idx) => (
                            <li key={idx}>
                              <Link to={`/${json.username}`}>{json.name}</Link>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            </ul>

            <ul className="auth-items-mob">
              <li className="skip w-100">
                <a className="login-button" href="/signin">
                  <span>Log In</span>
                </a>
              </li>
              <li className="skip w-100">
                <a href="/signup">
                  <span className="signup-button">Sign Up</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
